export default __webpack_public_path__ + "images/chatbot-agent.aac0af81.svg";